// **  Initial State
const initialState = {
    receipt: {}
}


const trackandtraceReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOAD_RECEIPT':


            return {
                ...state,
                receipt:{
                    ...state.receipt,
                    [action.receiptId] :{
                        loading:true,
                        errors:[]
                    }
                }
                
        }
        
        case 'LOAD_RECEIPT_SUCCESS':
            return {
                ...state,
                receipt:{
                    ...state.receipt,
                    [action.receiptData.id] :{
                        loading:false,
                        data:action.receiptData,
                        errors:[]
                    }
                }
                
        }

        case 'LOAD_RECEIPT_FAIL':
            return {
                ...state,
                receipt:{
                    ...state.receipt,
                    [action.receiptId] :{
                        loading:false,
                        errors:action.errors
                    }
                }
                
        }

        default:
        return state
    }
}

export default trackandtraceReducer